import { CodeEditor } from '../common/CodeEditor';
import type { ToolExecutionResult as ToolExecutionResultType } from '../../types/tool';

export interface ToolExecutionResultProps {
  result: ToolExecutionResultType | null;
}

/**
 * Displays the result of a tool execution or preview.
 */
export const ToolExecutionResult = ({ result }: ToolExecutionResultProps) => {
  if (!result) return null;

  return (
    <div className="mt-4">
      {!result.isSuccess ? (
        <div className="mb-2 rounded-md border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-800 dark:border-red-700 dark:bg-red-950 dark:text-red-300">
          {result.errorMessage || 'Tool execution failed'}
        </div>
      ) : (
        <div
          className={`mb-2 rounded-md border px-4 py-3 text-sm ${
            result.isDryRun
              ? 'border-amber-300 bg-amber-50 text-amber-800 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-300'
              : 'border-green-300 bg-green-50 text-green-800 dark:border-green-700 dark:bg-green-950 dark:text-green-300'
          }`}
        >
          {result.isDryRun ? 'Dry-run completed' : 'Execution completed'}
        </div>
      )}

      {result.impactPreviewJson && (
        <div className="mb-4">
          <p className="text-sm font-medium mb-2">
            Impact preview
          </p>
          <CodeEditor value={result.impactPreviewJson} language="json" height="200px" readOnly />
        </div>
      )}

      <p className="text-sm font-medium mb-2">
        Result
      </p>
      <CodeEditor value={result.result || ''} language="json" height="240px" readOnly />
    </div>
  );
};
